import React from 'react'
import _ from 'lodash'

import TextGroup from '../Texts'

const StrategyOne = ({ lang }) => {
const isEn = lang === 'en';
  return (
    <section id="strategy-one" className="content container">
      {isEn ? (
        <a href="/en/strategy-ESG/" className="back-strategy">
          Back to ESG Strategy
        </a>
      ) : (
        <a href="/estrategia-ESG/" className="back-strategy">
          Voltar para Estratégia ESG
        </a>
      )}
      <TextGroup
        rootProps={{ className: 'align-center' }}
        title={{
          type: 'h1',
          text: isEn ? 'Complaints Management Policy' : 'Política De Gestão De Reclamações',
        }}
      />
      {isEn ? (
        <>
        <h2>1. Introduction</h2>
        <p>log.oscon is committed to providing high quality services to its customers. We
        recognise that occasionally problems or dissatisfaction may arise in relation to our
        services. This complaints management policy has been developed to ensure that
        all complaints are dealt with effectively, fairly and in a timely manner.</p>

        <h2>2. Objective</h2>
        <p>The aim of this policy is to establish a clear and transparent procedure for
        receiving, recording, investigating and resolving complaints from our customers. In
        addition, we endeavour to identify areas for improvement in our processes based
        on the complaints received.</p>

        <h2>3. Responsibilities</h2>
        
        <h3>1. Complaints Handler</h3>
        <p>log.oscon will designate an employee responsible for handling complaints, who will
        be responsible for ensuring that all customer complaints are duly recorded,
        investigated and resolved.</p>
        <h3>2. Employees</h3>
        <p>All log.oscon employees are responsible for forwarding customer complaints to the
        complaints handler and co-operating in resolving them.</p>
        <h3>3. Receiving Complaints</h3>
        <p>Customer complaints can be submitted by telephone, e-mail, online form or any
        other available means. Employees must immediately forward complaints received
        to the person responsible for handling complaints.</p>
        <h3>4. Complaints Register</h3>
        <p>All complaints will be recorded in a complaints management system, including
        details such as the date of receipt, the description of the complaint, the customer's
        name, and any other relevant information.</p>

        <h2>4. Investigation of complaints</h2>
        <p>The complaints handler will investigate all complaints impartially and objectively.
        This may involve obtaining additional information from customers, consulting
        internal records and co-operating with other departments if necessary.</p>

        <h2>5. Complaint resolution</h2>
        <p>All complaints will be dealt with appropriately and fairly. log.oscon will take steps to
        resolve complaints as quickly as possible by communicating with the customer and
        explaining the actions taken to address the complaint.</p>

        <h2>6. Customer communication</h2>
        <p>log.oscon will keep the customer informed of the progress of the investigation and
        the resolution of the complaint. Communication will be carried out in a clear and
        respectful manner.</p>

        <h2>7. Recording and analysing</h2>
        <p>All complaints will be recorded in detail, including the actions taken to resolve
        them. Periodically, the company will analyse complaints data to identify trends and
        opportunities for improvement in its services.</p>

        <h2>8. Confidentiality</h2>
        <p>All complaints and related information will be treated with strict confidentiality and
        will only be shared with the parties involved in resolving the complaint.</p>

        <h2>9. Policy Review</h2>
        <p>This complaints management policy will be reviewed periodically to ensure its
        effectiveness and suitability for log.oscon's processes.
        log.oscon is committed to ensuring that all our customers' complaints are dealt with
        fairly and effectively, contributing to the continuous improvement of our services.
        We encourage our customers to lodge complaints whenever they consider it
        necessary, so that we can better serve their needs.
        </p>

        <a href="/en/strategy-ESG/" class="back-strategy-last">Back to ESG Strategy</a>
        </>
      ) : (
        <>
        <h2>1. Introdução</h2>
        <p>A log.oscon está comprometida em fornecer serviços de alta qualidade aos seus
        clientes. Reconhecemos que, ocasionalmente, podem surgir problemas ou
        insatisfações relacionados aos nossos serviços. Esta política de gestão de
        reclamações foi desenvolvida para garantir que todas as reclamações sejam
        tratadas de forma eficaz, justa e oportuna.</p>

        <h2>2. Objetivo</h2>
        <p>O objetivo desta política é estabelecer um procedimento claro e transparente para
        receber, registar, investigar e resolver as reclamações dos nossos clientes. Além
        disso, procuramos identificar áreas de melhoria nos nossos processos com base
        nas reclamações recebidas.</p>

        <h2>3. Responsabilidades</h2>
        
        <h3>1. Responsável Pelo Tratamento De Reclamações</h3>
        <p>A log.oscon designará um funcionário responsável pelo tratamento de
        reclamações, que será responsável por garantir que todas as reclamações dos
        clientes sejam devidamente registadas, investigadas e resolvidas.</p>
        <h3>2. Colaboradores</h3>
        <p>Todos os colaboradores da log.oscon são responsáveis por encaminhar as
        reclamações dos clientes ao responsável pelo tratamento de reclamações e
        cooperar na resolução das mesmas.</p>
        <h3>3. Receção De Reclamações</h3>
        <p>As reclamações dos clientes podem ser apresentadas por telefone, e-mail,
        formulário online ou qualquer outro meio disponível. Os colaboradores devem
        encaminhar imediatamente as reclamações recebidas ao responsável pelo
        tratamento de reclamações.</p>
        <h3>4. Registo De Reclamações</h3>
        <p>Todas as reclamações serão registadas num sistema de gestão de reclamações,
        incluindo detalhes como a data de receção, a descrição da reclamação, o nome do
        cliente, e quaisquer outras informações relevantes.</p>

        <h2>4. Investigação Das Reclamações</h2>
        <p>O responsável pelo tratamento de reclamações investigará todas as reclamações
        de forma imparcial e objetiva. Isso pode envolver a obtenção de informações
        adicionais dos clientes, a consulta de registos internos e a cooperação com outros
        departamentos, se necessário.</p>

        <h2>5. Resolução Das Reclamações</h2>
        <p>Todas as reclamações serão tratadas de forma apropriada e justa. A log.oscon
        tomará medidas para resolver as reclamações o mais rápido possível, comunicando
        com o cliente e explicando as ações tomadas para abordar a reclamação.</p>

        <h2>6. Comunicação Com O Cliente</h2>
        <p>A log.oscon manterá o cliente informado sobre o progresso da investigação e da
        resolução da reclamação. A comunicação será realizada de forma clara e
        respeitosa.</p>

        <h2>7. Registo E Análise</h2>
        <p>Todas as reclamações serão registadas em detalhe, incluindo as ações tomadas
        para a sua resolução. Periodicamente, a empresa analisará os dados das
        reclamações para identificar tendências e oportunidades de melhoria nos seus
        serviços.</p>

        <h2>8. Confidencialidade</h2>
        <p>Todas as reclamações e informações relacionadas serão tratadas com estrita
        confidencialidade, apenas sendo partilhadas com as partes envolvidas na
        resolução da reclamação.</p>

        <h2>9. Revisão Da Política</h2>
        <p>Esta política de gestão de reclamações será revista periodicamente para garantir a
        sua eficácia e adequação aos processos da log.oscon. A log.oscon está comprometida
        em garantir que todas as reclamações dos nossos clientes sejam tratadas de forma
        justa e eficaz, contribuindo para a melhoria contínua dos nossos serviços. Encorajamos
        os nossos clientes a apresentar reclamações sempre que considerarem necessário,
        para que possamos servir melhor as suas necessidades.</p>

        <a href="/estrategia-ESG/" class="back-strategy-last">Voltar para Estratégia ESG</a>
        </>
      )}
    </section>
  )
}
export default StrategyOne
